import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, switchMap, take, withLatestFrom } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';
import SettingsSelectors from '../store/settings/selectors';

@Injectable()
export class LocationInterceptor implements HttpInterceptor {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly store = inject(Store);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (
      !req.url.includes('/secure') &&
      !req.url.includes('/external/')
    ) {
      return next.handle(req);
    }

    if (!this.authenticationService.isLoggedIn()) {
      return EMPTY;
    }

    return this.store.pipe(
      withLatestFrom(
        this.store.select(SettingsSelectors.selectHasLocations),
        this.store.select(SettingsSelectors.selectSelectedLocation),
      ),
      take(1),
      switchMap(([_, hasLocations, selectedLocation]) =>
        !hasLocations || selectedLocation === undefined
          ? next.handle(req)
          : next.handle(
              req.clone({
                setHeaders: {
                  'Next-CustomerId': selectedLocation.CustomerId.toString(),
                  'Next-Locationid': selectedLocation.Id.toString(),
                },
              }),
            ),
      ),
    );
  }
}
